import React from 'react';
import { cn } from '@/lib/utils';
import { PerformanceOptimizedImage } from './PerformanceOptimizedImage';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  fallback?: React.ReactNode;
  loading?: 'lazy' | 'eager';
  gameType?: string;
  serverName?: string;
  imageType?: 'logo' | 'banner' | 'avatar' | 'category';
  width?: number;
  height?: number;
  priority?: boolean;
}

export const OptimizedImage: React.FC<OptimizedImageProps> = (props) => {
  return <PerformanceOptimizedImage {...props} />;
};